import { useEffect } from 'react';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { usePerformanceActions, useCurrentWorkspaceId, PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['lastExtractionDate']);

export const useMaintainPerformanceStoreState = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();
  const { lastExtractionDate } = usePerformanceState();

  const lastExtractionDates =
    Object.values(lastExtractionDate).length > 0 ? lastExtractionDate : null;

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    performanceActions.queryReviewsAccounts();
    performanceActions.queryWebsiteAccounts();
    performanceActions.queryResourceAccounts();
    performanceActions.restoreWorkspaceDataFromCache(currentWorkspaceId);

    performanceActions.queryChannelsAuthState().then(() => {
      performanceActions.queryConnectedAccounts(currentWorkspaceId);
    });

    return () => {
      performanceActions.cancelWaitRequests();
      performanceActions.clearStore(currentWorkspaceId);
    };
  }, [currentWorkspaceId, performanceActions]);

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }
    performanceActions.queryPerformanceCenterInfoForDocument();
  }, [currentWorkspaceId, lastExtractionDates, performanceActions]);
};
